module.exports = __webpack_public_path__ + "img/guide28802.6e8c873b.png";